import { Stack, Text } from '@backyard-ui/core';

import { type Review as ReviewType } from '@/infra/services/catalog/review/model';

import * as Review from '../../Review';

import { DetailsModal } from './DetailsModal';
import { DislikeIcon } from './DislikeIcon';
import { LikeIcon } from './LikeIcon';

interface ItemProps {
  isBad?: boolean;
  review: ReviewType;
}

function Item(props: ItemProps) {
  const { isBad, review } = props;

  const { author, date, text, rating, title } = review;

  return (
    <Stack direction="column" spacing="11">
      <Stack direction="row" spacing="2" align="center">
        {isBad ? (
          <>
            <LikeIcon />
            <Text size="lg" color="gray-600" asChild>
              <span>Avaliação favorável mais útil</span>
            </Text>
          </>
        ) : (
          <>
            <DislikeIcon />
            <Text size="lg" color="gray-600" asChild>
              <span>Avaliação crítica mais útil</span>
            </Text>
          </>
        )}
      </Stack>
      <Stack direction="column" align="flex-start" spacing="3">
        <Review.Head author={author} date={date} rating={rating} />
        <Review.Title>{title}</Review.Title>
        <Review.Description>{text}</Review.Description>
        <DetailsModal review={review} />
      </Stack>
    </Stack>
  );
}

export default Item;
